import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {
  buildExampleCatIndexItems,
  ExampleCatIndexItem,
  ExampleCatTree,
  ExamplePostpositionTree,
} from '../../models/example-tree.model';
import {GlobalEventService} from '../../services/global-event/global-event.service';

@Component({
  selector: 'app-example-cat-index',
  templateUrl: './example-cat-index.component.html',
  styleUrls: ['./example-cat-index.component.scss'],
})
export class ExampleCatIndexComponent {
  @Input()
  set treeList(treeList: Array<ExampleCatTree>) {
    this.catIndexList = buildExampleCatIndexItems(treeList ?? []);
  }
  @Input() selectedPostposition: ExamplePostpositionTree | null = null;
  @Output() select = new EventEmitter<ExamplePostpositionTree | null>();
  @Output() selectCat = new EventEmitter<ExampleCatIndexItem | null>();

  catIndexList: Array<ExampleCatIndexItem> = [];
  selectedCat: ExampleCatIndexItem | null = null;
  displayList: Array<ExamplePostpositionTree> = [];

  constructor(
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) { }

  public reset(): void {
    this.selectedCat = null;
    this.displayList = [];
  }

  public selectCatItem(cat: ExampleCatIndexItem): void {
    this.selectedCat = cat;
    this.displayList = cat.postpositions;
  }

  public get offsetHeight(): number {
    return this.elementRef.nativeElement.offsetHeight;
  }

  onClickCat($event: MouseEvent, cat: ExampleCatIndexItem): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    this.selectCatItem(cat);
    this.selectCat.emit(cat);
  }

  onClickReturn($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    this.selectedCat = null;
    this.displayList = [];
    this.selectCat.emit(null);
    this.select.emit(null);
  }


  onClickCatAll($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    this.select.emit(null);
  }

  onClickPostposition($event: MouseEvent, pp: ExamplePostpositionTree): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.globalEventSvc.Click($event, true);

    this.select.emit(pp);
  }
}
